<ng-template #collectionFilters>
  <app-data-filter #filter [fields]="filterFields" [values]="filterValues"
                   (change)="filter.apply()" (applied)="applyFilters($event)">
  </app-data-filter>
</ng-template>

<ng-container *workspaceView="'full'">
<section class="br-card br-card--dense">
  <header class="br-card-header">
    <h1 class="workspace-page__title">Contract Management</h1>
  </header>
  <div class="br-card-body">
  <!-- EVERY FIELD WITH BUSINESS MEANING is a column in the picker and a rule
       on the Filters panel, under the same id - which is also the server's
       sort key. The page opens on the five columns it always had.

       The picker key is new on purpose. The table skips its opening set for
       anyone with a stored choice, and every stored choice predates these
       columns: under the old key all of them would have appeared at once. -->
  <app-data-table [(search)]="collectionSearch" #table [columns]="columns" [fetch]="fetch"
                  [filters]="filterValues"
                  [defaultHiddenColumns]="defaultHiddenColumns"
                  searchPlaceholder="Customer, transaction code or contract number"
                  columnPickerKey="contracts"
                  [resizableColumns]="true"
                  [rowActions]="rowActionsTpl"
                  emptyText="No contract matches these filters.">

    <!-- Status is pinned and answers at once; every other column is a rule in
         the Filters panel, which batches its edits and asks once on Apply.
         Both share the table's command band with search. -->
    <div dt-filters><ng-container *ngTemplateOutlet="collectionFilters"></ng-container></div>

    <!-- Who the contract is with, and the way to them. Plain text, numbers and
         codes the table prints itself; a template here is only for a value
         that needs a format, a label or a link. -->
    <ng-template dtCell="customer" let-r>
      <a class="dt-link" *ngIf="ownerName(r) as name; else noOwner" (click)="openOwner(r)">{{ name }}</a>
      <span class="br-small br-text-muted" *ngIf="ownerTag(r) as tag"> · {{ tag }}</span>
      <ng-template #noOwner><span class="br-cell-empty">&#8212;</span></ng-template>
    </ng-template>

    <ng-template dtCell="tc" let-r>
      <span *ngIf="r.transactionCodeShortDescription">{{ r.transactionCodeShortDescription }}</span>
      <span *ngIf="!r.transactionCodeShortDescription" class="br-cell-empty">&#8212;</span>
    </ng-template>
    <ng-template dtCell="price" let-r>{{ r.price | currency }}</ng-template>
    <ng-template dtCell="entryDate" let-r>{{ r.entryDate | date:'mediumDate' }}</ng-template>

    <ng-template dtCell="status" let-r>
      <mat-chip [ngClass]="contractStatusClass(r.contractStatusCode)" disableRipple>
        {{ r.contractStatusLabel }}
      </mat-chip>
    </ng-template>

    <ng-template dtCell="effectiveFrom" let-r>{{ r.effectiveFrom | date:'mediumDate' }}</ng-template>
    <ng-template dtCell="effectiveTo" let-r>
      {{ noExpiry(r) ? 'No expiry' : (r.effectiveTo | date:'mediumDate') }}
    </ng-template>
    <ng-template dtCell="sentAt" let-r>{{ (r.sentAt | date:'mediumDate') || '&#8212;' }}</ng-template>
    <ng-template dtCell="signedOn" let-r>{{ (r.signedOn | date:'mediumDate') || '&#8212;' }}</ng-template>
    <ng-template dtCell="activatedAt" let-r>{{ (r.activatedAt | date:'mediumDate') || '&#8212;' }}</ng-template>
    <ng-template dtCell="terminatedAt" let-r>{{ (r.terminatedAt | date:'mediumDate') || '&#8212;' }}</ng-template>

    <ng-template dtCell="billingMethod" let-r>{{ billingMethodLabel(r.billingMethod) }}</ng-template>
    <ng-template dtCell="skipReducesBill" let-r>{{ r.skipReducesBill ? 'Yes' : 'No' }}</ng-template>
    <ng-template dtCell="emailScaleTicketClose" let-r>{{ r.emailScaleTicketClose ? 'Yes' : 'No' }}</ng-template>
    <ng-template dtCell="emailServiceOrderClose" let-r>{{ r.emailServiceOrderClose ? 'Yes' : 'No' }}</ng-template>
    <ng-template dtCell="allowedModificationTypes" let-r>{{ modificationLabels(r) || '&#8212;' }}</ng-template>

    <ng-template dtCell="createdAt" let-r>{{ r.createdAt | date:'mediumDate' }}</ng-template>
    <ng-template dtCell="createdBy" let-r>{{ r.createdByName || '&#8212;' }}</ng-template>
    <ng-template dtCell="updatedAt" let-r>{{ (r.updatedAt | date:'mediumDate') || '&#8212;' }}</ng-template>
    <ng-template dtCell="updatedBy" let-r>{{ r.updatedByName || '&#8212;' }}</ng-template>

    </app-data-table>

    <!-- Each contract's files: what is stored, opened or saved, and the
         signed copy added. -->
    <ng-template #rowActionsTpl let-r>
      <button mat-icon-button type="button" (click)="openDocuments(r)"
              matTooltip="Files" aria-label="Contract files" data-test="contract-files">
        <br-icon>attach_file</br-icon>
      </button>
    </ng-template>
  </div>
</section>
</ng-container>

<ng-container *workspaceView="'compact'">
  <section class="workspace-page workspace-page--full">
    <h1 class="workspace-page__title">Contracts</h1>

    <app-data-list #compactList [fetch]="fetch" [(search)]="collectionSearch" [filters]="filterValues">
      <div list-filters><ng-container *ngTemplateOutlet="collectionFilters"></ng-container></div>

      <ng-template dataListItem let-row>
        <strong>{{ ownerName(row) || 'Contract' }}</strong>
        <div class="br-text-muted">{{ row.contractStatusLabel }} · {{ row.price | currency }}</div>
      </ng-template>
      <ng-template dataListDetail let-row>
        <div>{{ row.transactionCodeShortDescription }}</div>
        <div>{{ row.entryDate | date:'mediumDate' }}</div>
      </ng-template>
    </app-data-list>
  </section>
</ng-container>
